import i18n from "../i18n.js"

const languages = [
    {
        label: 'English',
        value: 'en'
    },
    {
        label: 'Türkçe',
        value: 'tr'
    },
];

export class LanguageService {

    static getLanguages() {
        return languages;
    }

    static setLanguage(lng) {
        if (lng.toLowerCase() !== "en" && lng.toLowerCase() !== "tr")
            lng = i18n.fallbackLng;
        i18n.changeLanguage(lng);
        localStorage.setItem("i18nextLng", lng);
    }

    // The stored value is not always a bare 'tr'/'en'. On a first visit nothing
    // has called setLanguage yet, so what lands in localStorage is whatever
    // i18next detected from the browser -- a full BCP 47 tag such as 'tr-TR' or
    // 'en-US'. i18next itself copes (load: 'languageOnly' strips the region
    // before fetching the bundle, so the UI renders correctly), but an exact
    // comparison here does not: 'tr-TR' !== 'tr' answered 'en' for every
    // Turkish browser, which is how a third of Turkish signups were created as
    // English accounts -- wrong notification language, and a country/currency
    // the backend derives from this field. Strip the region before comparing.
    static getLanguage() {
        const stored = localStorage.getItem("i18nextLng") || i18n.fallbackLng;

        return String(stored).toLowerCase().split('-')[0] === 'tr' ? 'tr' : 'en';
    }
}
